/**
 * Helpers for crypto "up or down" automarkets (e.g. "Bitcoin Up or Down -
 * June 14, 12PM ET"). These resolve on the underlying asset price, so the
 * event page shows the ASSET price chart + "Price to Beat" strike rather than
 * the odds timeseries. Used for sources whose API doesn't expose the strike
 * (Predict) — CryptoPriceChart derives it from the open price at eventStartTime.
 */

/** True when a market title is a crypto up/down automarket we can chart.
 *  The symbol coverage mirrors CryptoPriceChart.detectCrypto. */
export function isCryptoUpDownTitle(title: string | null | undefined): boolean {
  if (!title || !/up\s*or\s*down/i.test(title)) return false;
  return /\b(btc|bitcoin|eth|ethereum|sol|solana|xrp|ripple|doge|dogecoin|bnb|hype|hyperliquid)\b/i.test(title);
}

/** Map a market's [startsAt, endsAt] window to CryptoPriceChart's interval.
 *  Returns null for windows outside the supported buckets (daily+). */
export function cryptoIntervalFromWindow(
  startsAt: string | null | undefined,
  endsAt: string | null | undefined,
): "5m" | "15m" | "1h" | "4h" | null {
  if (!startsAt || !endsAt) return null;
  const mins = Math.round((new Date(endsAt).getTime() - new Date(startsAt).getTime()) / 60000);
  if (!Number.isFinite(mins) || mins <= 0) return null;
  if (mins <= 7) return "5m";
  if (mins <= 20) return "15m";
  if (mins <= 90) return "1h";
  if (mins <= 300) return "4h";
  return null;
}
